(() => {
  'use strict';
  const trackingKeys = ['_su_rec', '_su_rec_id'];
  function cleanUrl(value) {
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (!trackingKeys.some(key => url.searchParams.has(key))) return null;
      trackingKeys.forEach(key => url.searchParams.delete(key));
      return url;
    } catch {
      return null;
    }
  }
  function cleanAddress() {
    const url = cleanUrl(location.href);
    if (url) history.replaceState(history.state, '', url.href);
  }
  function cleanLink(link) {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    const url = cleanUrl(href);
    if (url) link.setAttribute('href', url.href);
  }
  function cleanTree(root) {
    if (root.matches?.('a[href]')) cleanLink(root);
    root.querySelectorAll?.('a[href]').forEach(cleanLink);
  }
  cleanTree(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') cleanLink(record.target);
      else record.addedNodes.forEach(cleanTree);
    }
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href']
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link) cleanLink(link);
  }, true);
  document.addEventListener('contextmenu', event => {
    const link = event.target.closest?.('a[href]');
    if (link) cleanLink(link);
  }, true);
  window.addEventListener('pageshow', cleanAddress);
  window.addEventListener('popstate', cleanAddress);
  if (document.readyState === 'complete') cleanAddress();
  else window.addEventListener('load', cleanAddress, {once: true});
})();
